import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";

export const GTMDashboardEvent = (
  eventName: string,
  custom = {},
  options = [] as Array<string>
) => {
  dataLayer(eventName, custom, [...options, "userType", "userId", "username"]);
};
